import { supabase } from "@/integrations/supabase/client";

/**
 * Upload a base64-encoded PDF receipt to the public `receipts` bucket and
 * return its public URL. Path is `{userId}/{paymentId}.pdf` so RLS allows
 * the signed-in user to write under their own folder.
 */
export const uploadReceiptPdf = async (
  pdfBase64: string,
  userId: string,
  paymentId: string
): Promise<string | null> => {
  try {
    if (!userId) {
      console.warn("uploadReceiptPdf: missing userId, skipping upload");
      return null;
    }

    // Strip data URI prefix if present
    const base64Payload = pdfBase64.includes(",")
      ? pdfBase64.split(",")[1]
      : pdfBase64;

    // Decode base64 → Uint8Array (browser-safe)
    const binary = atob(base64Payload);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const path = `${userId}/${paymentId}.pdf`;

    const { error: uploadError } = await supabase.storage
      .from("receipts")
      .upload(path, bytes, {
        contentType: "application/pdf",
        upsert: true,
      });

    if (uploadError) {
      console.error("Failed to upload receipt PDF:", uploadError);
      return null;
    }

    const { data } = supabase.storage.from("receipts").getPublicUrl(path);
    return data?.publicUrl ?? null;
  } catch (err) {
    console.error("uploadReceiptPdf error:", err);
    return null;
  }
};
